/** The two chats-shell view kinds, discriminating `resolveChatsView`'s result.
 *
 * BOTH ARMS ARE HERE, not one. Until 2026-08-23 only the assistant arm had a const and `'tabbed'` was open-coded at its
 * return AND re-spelled a third time in the local result-type union -- so the discriminant that decides which shell
 * mounts was one named decision and two literals. A union arm restating a const SSOT is the same waste as a second
 * const: the type is now derived from these values (`typeof`), so an arm cannot be renamed in one place only.
 */

export const KIND_ASSISTANT_ONLY = 'assistant-only';

export const KIND_TABBED = 'tabbed';
